// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.legend {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 5px;
  z-index: 1000;
}

.legend h4 {
  margin-top: 0;
  margin-bottom: 5px;
}

.legend div {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}

.legend span {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  border: 1px solid #ccc;
}

.dust-symbol {
  width: 20px;
  height: 20px;
  background-color: #f0e68c;
  border: 1px solid #ccc;
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Legend.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":["\n.legend {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 10px;\n  border-radius: 5px;\n  z-index: 1000;\n}\n\n.legend h4 {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n.legend div {\n  display: flex;\n  align-items: center;\n  margin-bottom: 3px;\n}\n\n.legend span {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  border: 1px solid #ccc;\n}\n\n.dust-symbol {\n  width: 20px;\n  height: 20px;\n  background-color: #f0e68c;\n  border: 1px solid #ccc;\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
